import React, { useEffect, useState } from 'react';
import '../commandPanel.scss';
import useRockFetchGet from 'utils/RockFetch';
import { isNullOrUndefined } from 'utils/Global';
import { PlateInfoDTO, SavePlateInfoDto } from 'business/models/Models';
import { useRMDispatch, useRMSelector } from 'redux/hooks';
import { selectExp } from 'redux/selectors/ExperimentStateSelector';
import { setExperiment } from 'redux/reducers/experimentDataReducer';
import useRMLite from 'CustomHooks/useRMLite';
import { useLastSelectedWellNavigationDetails } from 'redux/hooks/experiment';
import {
  formatLocalDateTimeInputStr,
  shortDayMonthYearTimeFormat,
} from 'components/main/Hooks/ExperimentCommands/utils';

export type plateInfoProps = {
  label: string;
  text: any;
  type?: string;
  disabled?: boolean;
  onChange?: (val) => void;
};
let updatedPlateDispensed: SavePlateInfoDto[] = [];

function PlateInfoRow({ label, text, type, onChange, disabled = false }: plateInfoProps) {
  const [value, setValue] = useState(getFormattedValue(text));

  function getFormattedValue(input) {
    if (type === 'date' && input) {
      try {
        return formatLocalDateTimeInputStr(new Date(input));
      } catch (error) {
        console.warn('provided date is invalid', { input, error });
      }
    }
    return '';
  }

  function onChangeField(e: React.ChangeEvent<HTMLInputElement>) {
    const newVal = e.target.value;
    setValue(newVal);
    if (onChange) {
      onChange(newVal);
    }
  }

  return (
    <div id="plateinfo-wrapper" className="d-flex items-center">
      <div id={`plateinfo-label-${label}`} className="Plate-Info-Row-Label">{label}</div>
      {type === 'date' ? (
        <input
          className="Plate-Info-Row-Text min-w-min"
          onChange={onChangeField}
          value={value}
          type="datetime-local"
          id="plateinfo-plateDispensed"
          disabled={disabled}
        />
      ) : (
        <div id={`plateinfo-${text}`} className="Plate-Info-Row-Text">{text}</div>
      )}
    </div>
  );
}
export default function PlateInfo() {
  const wellNavigationDetails = useLastSelectedWellNavigationDetails();
  const [pInfo, setPlateInfo] = useState<PlateInfoDTO>();
  const [rockFetchGet] = useRockFetchGet();
  const exp = useRMSelector(selectExp);
  const dispatch = useRMDispatch();
  const rmLite = useRMLite();
  const { plateID } = wellNavigationDetails || {};

  function updateDispensedDates(dispensedDate: string, pId: number) {
    const filteredDispensedDate = updatedPlateDispensed.filter((pd) => pd.id !== pId);
    if (filteredDispensedDate.length === 0) {
      updatedPlateDispensed = [
        { id: pId, dispensedDate: new Date(dispensedDate) } as SavePlateInfoDto,
      ];
    } else {
      updatedPlateDispensed = [
        ...updatedPlateDispensed,
        { id: pId, dispensedDate: new Date(dispensedDate) } as SavePlateInfoDto,
      ];
    }
    if (!isNullOrUndefined(exp)) {
      dispatch(
        setExperiment({ plateDispensedDetails: updatedPlateDispensed, isDirty: true }),
      );
    }
  }
  useEffect(() => {
    async function fetchPlateInfo() {
      const url = `api/plate/pidata/false/${plateID}`;
      const data = await rockFetchGet(url, null, null, true);
      if (data === null) {
        return null;
      }
      setPlateInfo(data);
    }
    fetchPlateInfo();
  }, [plateID]);
  function onChangeDispensedDate(val) {
    updateDispensedDates(val, pInfo.id);
  }

  return (
    <>
      {pInfo && (
        <div id='plateinforow-container'>
          <PlateInfoRow label="ID" text={pInfo.id} />
          <PlateInfoRow label="Name" text={pInfo.name} />
          <PlateInfoRow
            label="Dispensed"
            text={pInfo.dispensed}
            type="date"
            onChange={onChangeDispensedDate}
            disabled={
              window.location.pathname.includes('/screen') || !pInfo.dispensed || rmLite
            }
          />
          <PlateInfoRow
            label="Imaged"
            text={
              pInfo.imaged
                ? new Date(pInfo.imaged).toLocaleTimeString(
                    'en-US',
                    shortDayMonthYearTimeFormat,
                  )
                : ''
            }
          />
          <PlateInfoRow label="Location" text={pInfo.robotName} />
        </div>
      )}
    </>
  );
}
